import React from "react"

export default function Club({ club }) {
    return (
        <p>{ club.name } <small title="Boat Code">({ club.boatCode })</small></p>
    )
}